import { useEffect, useRef } from "react";
import { useLocation, useNavigate, Navigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useApp } from "@/context/AppContext";

export function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { setUser } = useApp();
  const done = useRef(false);
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(location.hash.slice(1)).get("session_id");
    api.post("/auth/session", { session_id: sid })
      .then((r) => {
        setUser(r.data);
        const back = localStorage.getItem("ce_return") || "/account";
        localStorage.removeItem("ce_return");
        nav(back, { replace: true });
      })
      .catch(() => nav("/login", { replace: true }));
  }, [location.hash, nav, setUser]);
  return null;
}

export function Protected({ roles, children }) {
  const { user } = useApp();
  const location = useLocation();
  if (user === undefined) return <div className="min-h-[50vh] grid place-items-center text-[#6E6259]" data-testid="auth-loading">...</div>;
  if (!user) {
    localStorage.setItem("ce_return", location.pathname + location.search);
    return <Navigate to="/login" replace />;
  }
  if (roles && !roles.includes(user.role)) return <Navigate to="/account" replace />;
  if (user.must_change_password && user.session_method === "password") return <div className="min-h-[60vh]" />;
  return children;
}

export const startGoogleLogin = (returnTo) => {
  if (returnTo) localStorage.setItem("ce_return", returnTo);
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + "/account";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};
